module.exports = __webpack_public_path__ + "img/face-smile-hearts.d99e0e3.svg";